// https://github.com/moment/moment/issues/4877
// eslint-disable-next-line
import moment from "moment";
import { JS_TO_UNIX_MULTIPLIER } from "./constants";
import { IQueryParamsType } from "../hooks/useQueryParams";
import { ReactDatesMoment } from "../components/DatePicker";

export type DateRange = {
  startDate: ReactDatesMoment | null;
  endDate: ReactDatesMoment | null;
};

export const getQueryParamDateRange = (
  queryParams: IQueryParamsType
): DateRange => {
  if (queryParams) {
    return {
      startDate: queryParams.start
        ? ((moment(
            parseInt(queryParams.start.toString(), 10) * JS_TO_UNIX_MULTIPLIER
          ) as unknown) as ReactDatesMoment)
        : null,
      endDate: queryParams.end
        ? ((moment(
            parseInt(queryParams.end.toString(), 10) * JS_TO_UNIX_MULTIPLIER
          ) as unknown) as ReactDatesMoment)
        : null
    };
  }
  return {
    startDate: null,
    endDate: null
  };
};
